import type { QueryParams } from '@/api';
import { PAGE_SIZE } from '@/constants';
import camelToSnake from './camelToSnake';

export default function buildRequestParams(params: QueryParams): Record<string, string> {
  const query: Record<string, string> = {};
  if (params.page) {
    query['page'] = `${params.page}`;
    query['per_page'] = `${params?.perPage || PAGE_SIZE}`;
  }
  if (params.sort) {
    query['sort'] = params.sort
      .split(',')
      .map((s) => (s.startsWith('-') ? `-${camelToSnake(s.slice(1))}` : camelToSnake(s)))
      .join(',');
  }
  if (params.filter) {
    for (const [key, value] of Object.entries(params.filter)) {
      if (value) {
        query[`filter[${camelToSnake(key)}]`] = value;
      }
    }
  }
  if (params.range) {
    for (const [key, [min, max]] of Object.entries(params.range)) {
      query[`range[${camelToSnake(key)}]`] = `${min},${max}`;
    }
  }
  if (params.where) {
    query['where'] = params.where;
  }
  return query;
}
